"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistedTile = exports.PersistedChunk = void 0;
class PersistedChunk {
    constructor(chunkPosition, tiles) {
        this.chunkPosition = chunkPosition;
        this.tiles = tiles;
    }
}
exports.PersistedChunk = PersistedChunk;
class PersistedTile {
    constructor(flaggedBy, flagAsset, opened, mine) {
        this.flaggedBy = flaggedBy;
        this.flagAsset = flagAsset;
        this.opened = opened;
        this.mine = mine;
    }
    static flagged(by, asset) {
        return new PersistedTile(by, asset, false, true);
    }
    static closed(mine) {
        return new PersistedTile(undefined, undefined, false, mine);
    }
    static opened(mine) {
        return new PersistedTile(undefined, undefined, true, mine);
    }
}
exports.PersistedTile = PersistedTile;
//# sourceMappingURL=ChunkPersistence.js.map